module.exports = __webpack_public_path__ + "static/media/galerija_2019 (16).b310a0c3.jpg";